import Titol from 'components/3catinfo/Titol';
import Text from 'components/3catinfo/Text/Text';
import Imatge from 'components/3catinfo/Imatge';
import Icona from 'components/3catinfo/ui/Icona';
import Enllac from 'components/3catinfo/Enllac';
import styles from './capcaleraMunicipi.module.scss';
import AnimacioEclipsi from '../AnimacioEclipsi';

const CapcaleraMunicipi = (props) => {
    const { item } = props;
    const {
        nom,
        percentatgeReal,
        maxim = '-',
        duradaTotalitat = '-',
        alcadaSolMaxim = '-',
        iniciEclipsi = '-',
        iniciTotalitat = '-',
        fiTotalitat = '-',
        fiEclipsi = '-'
    } = item;
    const route = { slug: 'eclipsi-solar-2026', type: 'web_actualitat_seccio' };
    const percentatgeRealFormat =
        percentatgeReal === '-'
            ? percentatgeReal
            : percentatgeReal === 100
              ? percentatgeReal + '% de visibilitat'
              : percentatgeReal.toFixed(2).replace('.', ',') + '% de visibilitat';
    const alcadaSolFormat = alcadaSolMaxim.toString().replace('.', ',') + 'º';
    return (
        <div className={styles.capcaleraMunicipi}>
            <div className={styles.areaContent}>
                <Enllac route={route}>
                    <div className={styles.botoEnrere}>
                        <Icona icona={'fletxa_esquerra'} isBlanc={true} mida={28} />
                        <Imatge
                            src='https://statics.3cat.cat/recursos/3catinfo/img/eclipsi/titol_eclipsi.png'
                            objectFit='contain'
                            width='261'
                            height='20'
                        />
                    </div>
                </Enllac>
                <Titol titol={nom} className={styles.titol} />
                <div className={styles.contentWrapper}>
                    <AnimacioEclipsi percentatge={Math.floor(percentatgeReal)} />
                    <div className={styles.infoEclipsi}>
                        <div className={styles.infoCard}>
                            <Text text={percentatgeRealFormat} tag='span' className={styles.titolInfo} />
                            <div className={styles.infoGeneral}>
                                <div className={styles.maxim}>
                                    <Icona icona={'eclipsi_98'} className={styles.icona} mida={48} />
                                    <div>
                                        <Text text={'Màxim'} tag='p' />
                                        <Text text={maxim} tag='p' />
                                    </div>
                                </div>
                                <div className={styles.totalitat}>
                                    <Icona icona={'eclipsi_totalitat'} className={styles.icona} mida={48} />
                                    <div>
                                        <Text text={'Durada de la totalitat'} tag='p' />
                                        <Text text={duradaTotalitat} tag='p' />
                                    </div>
                                </div>
                                <div className={styles.alcada}>
                                    <Icona icona={'eclipsi_alcada_sol'} className={styles.icona} mida={48} />
                                    <div>
                                        <Text text={'Altura del Sol'} tag='p' />
                                        <Text text={alcadaSolFormat} tag='p' />
                                    </div>
                                </div>
                            </div>
                            <hr className={styles.separador} />
                            <div className={styles.infoHores}>
                                <div className={styles.iniciEclipsi}>
                                    <Text text={"Inici de l'eclipsi"} tag='p' />
                                    <Text text={iniciEclipsi} tag='p' />
                                </div>
                                <div className={styles.iniciTotalitat}>
                                    <Text text={'Inici de la totalitat'} tag='p' />
                                    <Text text={iniciTotalitat} tag='p' />
                                </div>
                                <div className={styles.fiTotalitat}>
                                    <Text text={'Fi de la totalitat'} tag='p' />
                                    <Text text={fiTotalitat} tag='p' />
                                </div>
                                <div className={styles.fiEclipsi}>
                                    <Text text={'Posta de sol'} tag='p' />
                                    <Text text={fiEclipsi} tag='p' />
                                </div>
                            </div>
                        </div>
                        <div className={styles.infoExtra}>
                            <Icona
                                icona={'info_contorn'}
                                className={styles.iconaInfo}
                                inline={true}
                                isBlanc={true}
                                alt='icona_info'
                            />
                            <Text
                                text={
                                    "El final de l'eclipsi és posterior a la posta de sol i, per tant, ja no es veurà. Per a una visibilitat òptima, cal tenir un horitzó totalment net per l'oest."
                                }
                                tag='p'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CapcaleraMunicipi;
